import { useFormik } from "formik";
import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardButton from "../../../../components/buttons/boardButton";

const AddEmployee = ({ t }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
    },
    onSubmit: (values) => {
      console.log("Submitted Data:", values);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="max-w-xl p-4 mx-auto space-y-5 bg-white dark:bg-gray-900 rounded-xl"
    >
      <BoardTextInput
        formik={formik}
        label={t("name")}
        name="name"
        className="text-black dark:text-white"
      />
      <BoardTextInput
        formik={formik}
        label={t("email")}
        name="email"
        className="text-black dark:text-white"
      />
      <BoardTextInput
        formik={formik}
        label={t("phone")}
        name="phone"
        className="text-black dark:text-white"
      />
      <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
        <BoardButton
          type="button"
          onClick={handleCancel}
          secondary
          bg
          className="w-full md:w-1/2"
        >
          {t("cancel")}
        </BoardButton>
        <BoardButton primary bg className="w-full md:w-1/2">
          {t("addEmployee")}
        </BoardButton>
      </div>
    </form>
  );
};

export default AddEmployee;
